/* lp-gift-cards — built by feral·landers. Edit landers/gift-cards/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-gift-cards",LP_NAME="gift-cards";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* ═══════════════════════════════════════════════════════════════════════════
   gift-cards — the builder. Runs after kit/base.js ($, $$, LP are live).

   One native Shopify gift card per issuance currency; the Liquid in page.html
   has already chosen the right one for this visitor and rendered every amount
   and price. 🚨 This file never formats money: the chip labels are the variant
   titles (the face value) and the price is Shopify's own `| money` string, in
   the visitor's market currency.

   Delivery is Shopify's native gift card recipient flow, the same line item
   properties the theme's recipient form posts, plus two hidden ones the card
   page reads back: `_design` (which art) and `_from` (who it is from).
   ═══════════════════════════════════════════════════════════════════════════ */

var D;
try { D = JSON.parse(document.getElementById('gc-data').textContent); } catch (e) { return; }
if (!D.v || !D.v.length) return;

var form = $('[data-gc-form]');
var card = $('[data-gc-card]');
var arts = $$('[data-gc-art]');
var dock = document.querySelector('[data-gc-dock]');   // portalled to <body> by base.js

/* ── THE HEADER'S EDGE ─────────────────────────────────────────────────────
   base.js measures the header group, whose first member is the marquee it
   hides, so --lp-chrome reads 0px here. The sticky stage needs the visible
   header's real bottom edge, which moves as the theme collapses it.        */
(function chrome() {
  var head = document.querySelector('.shopify-section.feral-h-section');
  if (!head) return;
  var write = function () {
    root.style.setProperty('--gc-chrome', Math.max(0, Math.round(head.getBoundingClientRect().bottom)) + 'px');
  };
  var t1, t2;
  var later = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);       // the theme animates the collapse
  };
  later();
  addEventListener('scroll', later, { passive: true });
  addEventListener('resize', later, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── THE CATALOGUE ─────────────────────────────────────────────────────── */
// v: [face, variantId, title, price]. Face is the number off the SKU.
var byFace = {};
D.v.forEach(function (r) { byFace[r[0]] = { face: r[0], id: r[1], label: r[2], price: r[3] }; });
var MIN = D.v[0][0], MAX = D.v[D.v.length - 1][0];
var STEP = D.v.length > 1 ? D.v[1][0] - D.v[0][0] : 1;
var PRESETS = {
  AUD: [50, 100, 150, 200, 300, 400],
  NOK: [250, 500, 750, 1000, 1500, 2000]
}[D.issued] || [25, 50, 75, 100, 150, 200];
PRESETS = PRESETS.filter(function (n) { return byFace[n]; });

var designs = {};
(D.designs || []).forEach(function (d) { designs[d.k] = d; });

var state = {
  design: (D.designs && D.designs[0] && D.designs[0].k) || '',
  face: byFace[D.def] ? D.def : PRESETS[0],
  other: false,
  who: 'them',
  when: 'now',
  sendOn: ''
};

/* ── DEEP LINK ─────────────────────────────────────────────────────────────
   ?design=strobe&amount=75 — so a card can be shared, or an email can land a
   customer on the birthday art already chosen. */
(function () {
  var q = new URLSearchParams(location.search);
  if (designs[q.get('design')]) state.design = q.get('design');
  var a = parseInt(q.get('amount'), 10);
  if (byFace[a]) { state.face = a; state.other = PRESETS.indexOf(a) < 0; }
})();
function writeUrl() {
  if (!history.replaceState) return;
  var q = new URLSearchParams(location.search);
  q.set('design', state.design);
  q.set('amount', String(state.face));
  history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
}

/* ── DESIGN ────────────────────────────────────────────────────────────── */
var artOn = 0, artToken = 0;
function showArt(key) {
  var d = designs[key];
  if (!d) return;
  var cur = arts[artOn];
  if (cur.getAttribute('data-k') === key) return;
  var next = arts[1 - artOn];
  var token = ++artToken;
  next.onload = null;
  next.srcset = d.s + ' 800w, ' + d.l + ' 1600w';
  next.sizes = '(min-width: 990px) 44vw, 92vw';
  next.src = d.s;
  var swap = function () {
    if (token !== artToken) return;             // a later tap won
    next.classList.add('is-on');
    next.alt = 'FERAL gift card, ' + d.n + ' design';
    next.removeAttribute('aria-hidden');
    next.setAttribute('data-k', key);
    cur.classList.remove('is-on');
    cur.alt = '';
    cur.setAttribute('aria-hidden', 'true');
    artOn = 1 - artOn;
  };
  // decode() first so the fade never shows a half-painted image
  if (next.decode) next.decode().then(swap, swap);
  else if (next.complete) swap();
  else next.onload = swap;
}

function setDesign(key, quiet) {
  if (!designs[key]) return;
  state.design = key;
  $$('[data-gc-design]').forEach(function (b) {
    b.setAttribute('aria-pressed', String(b.getAttribute('data-gc-design') === key));
  });
  showArt(key);
  if (!quiet) flip(false);
  paint();
  if (!quiet) writeUrl();
}

$$('[data-gc-design]').forEach(function (b) {
  b.addEventListener('click', function () { setDesign(b.getAttribute('data-gc-design')); });
});

/* occasion filter: the chosen design stays chosen unless the filter hides it */
$$('[data-gc-occ]').forEach(function (b) {
  b.addEventListener('click', function () {
    var occ = b.getAttribute('data-gc-occ');
    $$('[data-gc-occ]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    var first = null, keep = false;
    $$('.gc-designs__cell').forEach(function (li) {
      var show = occ === 'all' || li.getAttribute('data-occ') === occ;
      li.hidden = !show;
      if (!show) return;
      var k = li.querySelector('[data-gc-design]').getAttribute('data-gc-design');
      if (!first) first = k;
      if (k === state.design) keep = true;
    });
    if (!keep && first) setDesign(first);
    var rail = $('[data-gc-designs]');
    if (rail.scrollTo) rail.scrollTo({ left: 0, behavior: LP.reduced ? 'auto' : 'smooth' });
  });
});

/* ── AMOUNT ────────────────────────────────────────────────────────────── */
var presetsEl = $('[data-gc-presets]');
var otherWrap = $('[data-gc-other]');
var otherIn = $('[data-gc-other-input]');
var hint = $('[data-gc-amount-hint]');
var hintBase = hint.textContent;

presetsEl.innerHTML = PRESETS.map(function (n) {
  return '<button type="button" class="gc-chip" data-gc-face="' + n + '" aria-pressed="false">' +
         LP.esc(byFace[n].label) + '</button>';
}).join('') + '<button type="button" class="gc-chip gc-chip--other" data-gc-face="other" aria-pressed="false">Other</button>';
// "A$150" and "1 500 kr" do not fit seven to a row; they keep four
presetsEl.classList.toggle('gc-amounts--wide', PRESETS.some(function (n) { return byFace[n].label.length > 4; }));

function snap(n) {
  if (!isFinite(n)) return state.face;
  n = Math.round((n - MIN) / STEP) * STEP + MIN;
  return Math.min(MAX, Math.max(MIN, n));
}

function setFace(n, opts) {
  opts = opts || {};
  if (!byFace[n]) return;
  var changed = n !== state.face;
  state.face = n;
  if (opts.other !== undefined) state.other = opts.other;
  $$('[data-gc-face]', presetsEl).forEach(function (b) {
    var v = b.getAttribute('data-gc-face');
    b.setAttribute('aria-pressed', String(state.other ? v === 'other' : v === String(n)));
  });
  otherWrap.hidden = !state.other;
  if (state.other && opts.fromInput !== true) otherIn.value = String(n);
  if (changed && !opts.quiet) flip(false);
  if (changed && !LP.reduced) {
    card.classList.remove('is-bump');
    void card.offsetWidth;                       // restart the animation
    card.classList.add('is-bump');
  }
  paint();
  if (!opts.quiet) writeUrl();
}

presetsEl.addEventListener('click', function (e) {
  var b = e.target.closest('[data-gc-face]');
  if (!b) return;
  var v = b.getAttribute('data-gc-face');
  if (v === 'other') {
    setFace(state.face, { other: true });
    otherIn.focus();
    otherIn.select();
  } else {
    setFace(parseInt(v, 10), { other: false });
    hint.textContent = hintBase;
  }
});

/* Typing: the card follows the nearest amount we can issue, but nothing ever
   rewrites the field under someone's fingers. It settles on blur or Enter. */
otherIn.addEventListener('input', function () {
  var raw = parseInt(otherIn.value.replace(/[^\d]/g, ''), 10);
  if (!isFinite(raw)) { hint.textContent = hintBase; return; }
  var n = snap(raw);
  hint.textContent = n === raw ? hintBase
    : raw < MIN ? 'The smallest card is ' + byFace[MIN].label + '.'
    : raw > MAX ? 'The biggest card is ' + byFace[MAX].label + '.'
    : 'Cards go up in steps of ' + STEP + '. This one would be ' + byFace[n].label + '.';
  setFace(n, { fromInput: true });
});
function settleOther() {
  otherIn.value = String(state.face);
  hint.textContent = hintBase;
}
otherIn.addEventListener('blur', settleOther);
otherIn.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') { e.preventDefault(); settleOther(); otherIn.blur(); }
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault();
    setFace(snap(state.face + (e.key === 'ArrowUp' ? STEP : -STEP)));
  }
});
$$('[data-gc-bump]').forEach(function (b) {
  b.addEventListener('click', function () {
    setFace(snap(state.face + STEP * parseInt(b.getAttribute('data-gc-bump'), 10)));
    hint.textContent = hintBase;
  });
});

/* ── WHO + WHEN ────────────────────────────────────────────────────────── */
var them = $('[data-gc-them]');
var meNote = $('[data-gc-me]');
var whenStep = $('[data-gc-when-step]');
var rname = $('[data-gc-rname]');
var remail = $('[data-gc-remail]');
var msg = $('[data-gc-msg]');
var from = $('[data-gc-from]');
var count = $('[data-gc-count]');

$$('[data-gc-who]').forEach(function (b) {
  b.addEventListener('click', function () {
    state.who = b.getAttribute('data-gc-who');
    $$('[data-gc-who]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    them.hidden = state.who !== 'them';
    meNote.hidden = state.who !== 'me';
    // a scheduled send only exists for a recipient; a card for yourself comes after checkout
    whenStep.hidden = state.who !== 'them';
    // the note on the back is for a recipient; a card for yourself has only a front
    flipBtn.hidden = state.who !== 'them';
    if (state.who !== 'them') flip(false);
    clearErr();
    paint();
  });
});

msg.addEventListener('input', function () {
  count.textContent = msg.value.length + ' / 200';
  setErr('message', '');
  paint();
});
rname.addEventListener('input', paint);
from.addEventListener('input', paint);
// writing the note turns the card to the note
[rname, msg, from].forEach(function (el) { el.addEventListener('focusin', function () { flip(true); }); });
remail.addEventListener('input', function () {
  if (remail.getAttribute('aria-invalid') === 'true' && EMAIL.test(remail.value.trim())) setErr('email', '');
});

var cal = $('[data-gc-cal]');
$$('[data-gc-when]').forEach(function (b) {
  b.addEventListener('click', function () {
    state.when = b.getAttribute('data-gc-when');
    $$('[data-gc-when]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    cal.hidden = state.when !== 'later';
    if (state.when === 'later') drawCal();
    setErr('send_on', '');
    paint();
  });
});

/* ── THE CALENDAR ──────────────────────────────────────────────────────────
   Our own, not <input type="date">: the native one is a different control on
   every phone and cannot be told "tomorrow to 90 days out" in a way iOS
   honours. Shopify accepts a send date up to 90 days ahead. */
var DAY = 864e5;
var today = new Date(); today.setHours(0, 0, 0, 0);
var first = new Date(today.getTime() + DAY);
var last = new Date(today.getTime() + 90 * DAY);
var view = new Date(first.getFullYear(), first.getMonth(), 1);
var calGrid = $('[data-gc-cal-grid]');
var calMonth = $('[data-gc-cal-month]');
var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var pad = function (n) { return (n < 10 ? '0' : '') + n; };
var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
function fromIso(s) { var p = s.split('-'); return new Date(+p[0], p[1] - 1, +p[2]); }
function shortDate(s) {
  var d = fromIso(s);
  return DAYS[d.getDay()].slice(0, 3) + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()].slice(0, 3);
}

function drawCal() {
  var y = view.getFullYear(), m = view.getMonth();
  calMonth.textContent = MONTHS[m] + ' ' + y;
  var lead = (new Date(y, m, 1).getDay() + 6) % 7;          // Monday first
  var days = new Date(y, m + 1, 0).getDate();
  var html = '';
  for (var i = 0; i < lead; i++) html += '<span aria-hidden="true"></span>';
  for (var d = 1; d <= days; d++) {
    var dt = new Date(y, m, d);
    var label = DAYS[dt.getDay()] + ' ' + d + ' ' + MONTHS[m];
    if (dt < first || dt > last) {
      html += '<span class="gc-cal__day gc-cal__day--off lp-num" aria-hidden="true">' + d + '</span>';
    } else {
      var s = iso(dt);
      html += '<button type="button" class="gc-cal__day lp-num" data-gc-day="' + s + '" aria-label="' + label +
              '" aria-pressed="' + String(s === state.sendOn) + '">' + d + '</button>';
    }
  }
  calGrid.innerHTML = html;
  var prev = $('[data-gc-cal-nav="-1"]'), next = $('[data-gc-cal-nav="1"]');
  prev.disabled = y === first.getFullYear() && m === first.getMonth();
  next.disabled = y === last.getFullYear() && m === last.getMonth();
}
$$('[data-gc-cal-nav]').forEach(function (b) {
  b.addEventListener('click', function () {
    view = new Date(view.getFullYear(), view.getMonth() + parseInt(b.getAttribute('data-gc-cal-nav'), 10), 1);
    drawCal();
  });
});
calGrid.addEventListener('click', function (e) {
  var b = e.target.closest('[data-gc-day]');
  if (!b) return;
  state.sendOn = b.getAttribute('data-gc-day');
  $$('[data-gc-day]', calGrid).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
  setErr('send_on', '');
  paint();
  flip(true);
});

/* ── PAINT: everything that reads the state ────────────────────────────── */
var capDesign = $('[data-gc-cap-design]');
var capTo = $('[data-gc-cap-to]');
var amt = $('[data-gc-amt]');
var ctaPrice = $('[data-gc-cta-price]');
var notePay = $('[data-gc-note-pay]');
var noteFace = $('[data-gc-note-face]');
var dockAmt = dock && dock.querySelector('[data-gc-dock-amt]');
var dockSub = dock && dock.querySelector('[data-gc-dock-sub]');
var dockThumb = dock && dock.querySelector('[data-gc-dock-thumb]');
var backAmt = $('[data-gc-back-amt]');
var backTo = $('[data-gc-back-to]');
var backMsg = $('[data-gc-back-msg]');
var backFrom = $('[data-gc-back-from]');
var backWhen = $('[data-gc-back-when]');
var MSG_EMPTY = backMsg.textContent;

function paint() {
  var v = byFace[state.face], d = designs[state.design];
  amt.textContent = v.label;
  // what they pay: the face value in its own currency, or Shopify's converted price
  ctaPrice.textContent = D.fallback ? v.price : v.label;
  if (notePay) notePay.textContent = D.fallback ? v.price : v.label;
  if (noteFace) noteFace.textContent = v.label;
  if (d) capDesign.textContent = d.n;
  var name = rname.value.trim();
  var to = state.who === 'me' ? 'Emailed to you'
         : name ? 'Emailed to ' + name
         : 'Emailed to them';
  if (state.who === 'them') to += state.when === 'later' && state.sendOn ? ' on ' + shortDate(state.sendOn) : ' after checkout';
  capTo.textContent = to;
  if (dockAmt) dockAmt.textContent = D.fallback ? v.price : v.label;
  if (dockSub && d) dockSub.textContent = d.n + (D.fallback ? ' · ' + v.label + ' card' : ' gift card');
  if (dockThumb && d) dockThumb.style.backgroundImage = 'url("' + d.s + '")';
  // the back: the note as they will read it
  var m = msg.value.trim(), f = from.value.trim();
  backAmt.textContent = v.label;
  backTo.textContent = name ? 'For ' + name : 'For you';
  backMsg.textContent = m || MSG_EMPTY;
  backMsg.classList.toggle('is-empty', !m);
  backMsg.classList.toggle('is-long', m.length > 90);
  backFrom.textContent = f ? 'From ' + f : 'From you';
  backFrom.classList.toggle('is-empty', !f);
  backWhen.textContent = state.when === 'later' && state.sendOn ? 'Arrives ' + shortDate(state.sendOn) : 'Arrives after checkout';
}

/* ── THE FLIP — the front is the art, the back is their note ──────────────── */
var flipBtn = $('[data-gc-flip]');
var flipLabel = $('[data-gc-flip-label]');
var front = $('[data-gc-front]');
var back = $('[data-gc-back]');
var flipped = false, flipping = 0;
function flip(on) {
  on = !!on && state.who === 'them';
  if (on === flipped) return;
  flipped = on;
  card.classList.remove('is-tilting');           // the turn gets the slow curve, not the tilt's
  clearTimeout(flipping);
  flipping = setTimeout(function () { flipping = 0; }, 800);
  card.classList.toggle('is-flipped', on);
  flipBtn.setAttribute('aria-pressed', String(on));
  flipLabel.textContent = on ? 'Flip to card' : 'Flip to note';
  front.setAttribute('aria-hidden', String(on));
  back.setAttribute('aria-hidden', String(!on));
}
flipBtn.addEventListener('click', function () { flip(!flipped); });

/* phone: the card is a long way up while you type the note, so bring it back */
$('[data-gc-peek]').addEventListener('click', function () {
  $('[data-gc-stage]').scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'center' });
  setTimeout(function () { flip(true); }, LP.reduced ? 0 : 350);
});

/* ── TILT — a mouse only; a card that moves under a thumb is a bug ──────── */
(function tilt() {
  if (LP.reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var stage = $('[data-gc-stage]');
  var raf = 0;
  stage.addEventListener('pointermove', function (e) {
    var r = card.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      if (!flipping) card.classList.add('is-tilting');
      card.style.setProperty('--gc-ry', ((x - .5) * 10).toFixed(2) + 'deg');
      card.style.setProperty('--gc-rx', ((.5 - y) * 8).toFixed(2) + 'deg');
      card.style.setProperty('--gc-mx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gc-my', (y * 100).toFixed(1) + '%');
    });
  });
  stage.addEventListener('pointerleave', function () {
    if (raf) cancelAnimationFrame(raf);
    card.classList.remove('is-tilting');
    ['--gc-rx', '--gc-ry', '--gc-mx', '--gc-my'].forEach(function (p) { card.style.removeProperty(p); });
  });
})();

/* ── ERRORS ────────────────────────────────────────────────────────────── */
var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
var FIELD = { email: remail, message: msg, send_on: null, name: rname };
function setErr(key, text) {
  var el = $('[data-gc-err="' + key + '"]');
  if (el) el.textContent = text;
  if (FIELD[key]) {
    if (text) FIELD[key].setAttribute('aria-invalid', 'true');
    else FIELD[key].removeAttribute('aria-invalid');
  }
}
function clearErr() { ['email', 'message', 'send_on', 'buy'].forEach(function (k) { setErr(k, ''); }); }

function validate() {
  clearErr();
  var bad = null;
  if (state.who === 'them') {
    var e = remail.value.trim();
    if (!e) { setErr('email', 'Add their email so we know where to send it.'); bad = bad || remail; }
    else if (!EMAIL.test(e)) { setErr('email', 'That email doesn’t look right.'); bad = bad || remail; }
    if (state.when === 'later' && !state.sendOn) {
      setErr('send_on', 'Pick the day it should arrive.');
      bad = bad || $('[data-gc-cal-grid] [data-gc-day]') || $('[data-gc-when="later"]');
    }
  }
  if (bad) {
    bad.scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'center' });
    bad.focus({ preventScroll: true });
    return false;
  }
  return true;
}

/* ── ADD TO BAG ────────────────────────────────────────────────────────────
   The theme's own product-form shape (top-level id / quantity / properties,
   form-encoded) so Shopify validates the recipient exactly as it does for
   the native form and answers errors keyed email / name / message / send_on.
   The drawer's sections ride in the same request (part: cart-add-with-section-
   rerender); LP.addToCart cannot carry properties, so this is its twin.      */
var cta = $('[data-gc-add]');
var ctaLabel = $('[data-gc-cta-label]');
var busy = false;

function add() {
  if (busy || !validate()) return;
  busy = true;
  cta.classList.add('is-busy');
  cta.setAttribute('aria-busy', 'true');
  var v = byFace[state.face];
  var fd = new FormData();
  fd.append('id', String(v.id));
  fd.append('quantity', '1');
  fd.append('properties[_design]', state.design);
  if (state.who === 'them') {
    fd.append('properties[__shopify_send_gift_card_to_recipient]', 'on');
    fd.append('properties[Recipient email]', remail.value.trim());
    if (rname.value.trim()) fd.append('properties[Recipient name]', rname.value.trim());
    if (msg.value.trim()) fd.append('properties[Message]', msg.value.trim());
    if (state.when === 'later' && state.sendOn) fd.append('properties[Send on]', state.sendOn);
    fd.append('properties[__shopify_offset]', String(new Date().getTimezoneOffset()));
    if (from.value.trim()) fd.append('properties[_from]', from.value.trim());
  }
  var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  if (drawer && typeof drawer.getSectionsToRender === 'function') {
    fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', location.pathname);
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        var handled = false;
        if (data.errors && typeof data.errors === 'object') {
          Object.keys(data.errors).forEach(function (k) {
            var text = [].concat(data.errors[k]).join(', ');
            if ($('[data-gc-err="' + k + '"]')) { setErr(k, text.replace(/\.?$/, '.')); handled = true; }
          });
        }
        if (!handled) setErr('buy', data.description || data.message || 'That didn’t go through. Try again.');
        return;
      }
      if (!data.variant_id) {
        // an issuance-currency card bought in another currency is refused with a 200
        setErr('buy', 'That didn’t go through. Refresh the page and try again.');
        return;
      }
      if (!drawer) { location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      if (typeof drawer.renderContents === 'function') drawer.renderContents(data);
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, productVariantId: v.id, cartData: data });
      }
      ctaLabel.textContent = 'Added';
      setTimeout(function () { ctaLabel.textContent = 'Add to bag'; }, 2400);
    })
    .catch(function () { setErr('buy', 'That didn’t go through. Check your connection and try again.'); })
    .finally(function () {
      busy = false;
      cta.classList.remove('is-busy');
      cta.removeAttribute('aria-busy');
    });
}
form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

/* ── THE DOCK (phone) ──────────────────────────────────────────────────────
   Up only while neither the card nor the real button is on screen, and down
   while someone is typing: a bar floating over the keyboard hides the field. */
(function dockWire() {
  if (!dock || !('IntersectionObserver' in window)) return;
  var seen = { stage: true, buy: false };
  var typing = false;
  var sync = function () { dock.classList.toggle('is-up', !seen.stage && !seen.buy && !typing); };
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { seen[e.target === cta ? 'buy' : 'stage'] = e.isIntersecting; });
    sync();
  }, { threshold: 0 });
  io.observe($('[data-gc-stage]'));
  io.observe(cta);
  form.addEventListener('focusin', function (e) { typing = /^(INPUT|TEXTAREA)$/.test(e.target.tagName); sync(); });
  form.addEventListener('focusout', function () { typing = false; setTimeout(sync, 60); });
  dock.querySelector('[data-gc-dock-add]').addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else add();
  });
})();

/* ── START ─────────────────────────────────────────────────────────────────
   Quiet: the URL only gains ?design=&amount= once someone chooses. */
arts[0].setAttribute('data-k', D.designs[0].k);   // the server painted the first design
setDesign(state.design, true);
setFace(state.face, { other: state.other, quiet: true });

/* ── GOT ONE: the balance check ────────────────────────────────────────────
   FeralGift (assets/feral-gift-wallet.js, loaded on every page) reads the
   balance off a throwaway Storefront cart in this visitor's currency. "Shop
   with it" keeps the card on this device and the bag puts it on by itself. */
(function balanceCheck() {
  var f = $('[data-gc-check]');
  if (!f) return;
  var input = $('[data-gc-check-code]', f);
  var go = $('[data-gc-check-go]', f);
  var err = $('[data-gc-check-err]', f);
  var out = $('[data-gc-check-out]');
  var amtEl = $('[data-gc-check-amt]');
  var sub = $('[data-gc-check-sub]');
  var shop = $('[data-gc-check-shop]');
  var again = $('[data-gc-check-again]');
  var sample = f.getAttribute('data-money-sample');
  var found = null;

  // groups of four as they type, the way the card prints it
  input.addEventListener('input', function () {
    err.textContent = '';
    input.removeAttribute('aria-invalid');
    var raw = input.value.replace(/[^a-z0-9]/gi, '').slice(0, 20);
    var pretty = raw.replace(/(.{4})(?=.)/g, '$1 ');
    if (pretty !== input.value) input.value = pretty;
  });

  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = input.value.replace(/[^a-z0-9]/gi, '');
    if (code.length < 8) {
      err.textContent = 'That’s shorter than a gift card code. It’s in the email, under “Your code”.';
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    if (!window.FeralGift) { err.textContent = 'That didn’t load. Refresh the page and try again.'; return; }
    go.classList.add('is-busy');
    go.textContent = 'Checking…';
    window.FeralGift.balance(code).then(function (r) {
      if (!r.ok) {
        err.textContent = 'We can’t find a card with that code. Check it against the email, or write to hey@feralclo.com.';
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      found = code;
      amtEl.textContent = window.FeralGift.money(r.amount, sample);
      sub.textContent = r.amount > 0
        ? 'Card ending ' + r.last4.toUpperCase() + '. Spend it in one go or over time.'
        : 'Card ending ' + r.last4.toUpperCase() + '. This one is spent.';
      shop.hidden = !(r.amount > 0);
      f.hidden = true;
      out.hidden = false;
      out.scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'nearest' });
    }, function () {
      err.textContent = 'That didn’t go through. Check your connection and try again.';
    }).then(function () {
      go.classList.remove('is-busy');
      go.textContent = 'Check balance';
    });
  });

  shop.addEventListener('click', function () {
    if (found && window.FeralGift) window.FeralGift.keep(found, { a: amtEl.textContent, fresh: 1 });
  });
  again.addEventListener('click', function () {
    found = null;
    input.value = '';
    out.hidden = true;
    f.hidden = false;
    input.focus();
  });
})();

})();